import { Either } from 'monet';

/**
 * @description Обновление
 * @param {number} id
 * @param {string} title
 * @param {string} description
 * @param {string} linkAnchor
 * @param {string} photoUrl
 * @param {string} vote
 */
export function Update(
  id,
  title = '',
  description = '',
  linkAnchor = '',
  photoUrl = '',
  vote = '',
) {
  this.id = id;
  this.title = title;
  this.description = description;
  this.linkAnchor = linkAnchor;
  this.photoUrl = photoUrl;
  this.vote = vote;
}

/**
 * @description Шлюз обновлений.
 * @param {AxiosStatic} axios Http клиент.
 * @constructor
 */
export default function UpdatesGateway(axios) {
  /**
   * @description Сохранить комментарий.
   * @param {number} updateId
   * @param {string} comment
   * @returns {Promise<Either>}
   */
  this.storeComment = (updateId, comment) => axios
    .post(`/api/updates/${updateId}/comments`, { comment })
    .then(
      (response) => Either.right(response.data.data.message),
      (error) => {
        if (error.isAxiosError && [400, 404].includes(error.response.status)) {
          return Either.left(error.response.data);
        }
        throw error;
      },
    );

  /**
   * @description Получить список обновлений.
   * @returns {Promise<Update>}
   */
  this.viewUpdates = async () => {
    const requestUrl = '/api/updates';
    try {
      const response = await axios.get(requestUrl);
      const { data } = response.data;
      const updates = data.updates.map((item) => new Update(
        item.id,
        item.title,
        item.description,
        item.link_anchor,
        item.photo_url,
        item.vote,
      ));
      const statusUpdateModal = data.status_update_modal;
      return { updates, statusUpdateModal };
    } catch (error) {
      if (error.isAxiosError) {
        if (error.response) {
          return Either.Left(error.response.data);
        }
        throw new Error(`Network error: сервер по адресу ${requestUrl} не ответил на запрос`);
      }
      throw error;
    }
  };

  /**
   * @description Показать по идентификатору.
   * @param {number} updateId Идентификатор обновления.
   * @returns {Promise<Either>}
   */
  this.viewById = (updateId) => axios
    .get(`/api/updates/${updateId}`)
    .then(
      (response) => {
        const { data } = response.data;
        return Either.right(new Update(
          data.id,
          data.title,
          data.description,
          data.link_anchor,
          data.photo_url,
          data.vote,
        ));
      },
      (error) => {
        if (error.isAxiosError && error.response.status === 404) {
          return Either.left(error.response.data);
        }
        throw error;
      },
    );

  /**
   * @description Оценить обновление.
   * @param {number} updateId
   * @param {string} vote
   * @returns {Promise<Either>}
   */
  this.rateUpdate = async (updateId, vote) => {
    try {
      const response = await axios.post(`/api/updates/${updateId}/vote`, { vote });
      return Either.Right({ title: response.data.title });
    } catch (error) {
      if (error.isAxiosError) {
        return Either.Left(error.response.data);
      }
      throw error;
    }
  };
}
